module.exports = __webpack_public_path__ + "static/media/fpm1.dc8449bf.png";